{
  "$id": "urn:dm:schemas:cssPropertySchemas.json",
  "title": "CSS Property Schemas",
  "description": "Individual JSON Schema definitions for CSS property value types used within Wix",
  "definitions": {
    "CSS.Color": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<css-value-containing-var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<color>",
              "format": "css-color"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.BlendMode": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<blend-mode>",
              "format": "css-blend-mode"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.Angle": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<angle>",
              "format": "css-angle"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.LengthPercentage": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<length-percentage>",
              "format": "css-length-percentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.PositiveLengthPercentage": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-length-percentage>",
              "format": "css-length-percentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.Length": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<length>",
              "format": "css-length"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.PositiveLength": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-length>",
              "format": "css-length"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.Number": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<number>",
              "format": "css-number"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.PositiveNumber": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-number>",
              "format": "css-number"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.Percentage": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<percentage>",
              "format": "css-percentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.PositivePercentage": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-percentage>",
              "format": "css-percentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.String": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<string>",
              "format": "css-string"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.Time": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<time>",
              "format": "css-time"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.BorderTopStyle": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<line-style>",
              "format": "css-border-top-style"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.BorderTopWidth": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<line-width>",
              "format": "css-border-top-width"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.BorderWidth": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "description": "this ref needs to be changed to shorthand syntax of the ref",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border-width>",
              "format": "css-border-width"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.BorderStyle": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "description": "this ref needs to be changed to shorthand syntax of the ref",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border-style>",
              "format": "css-border-style"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.BorderColor": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Color"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "description": "this ref needs to be changed to shorthand syntax of the ref",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<color>",
              "format": "css-border-color"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.Border": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border>",
              "format": "css-border"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.BorderRadius": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border-radius>",
              "description": "border radius shorthand syntax",
              "format": "css-border-radius"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.BorderTopLeftRadius": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<border-top-left-radius>",
              "format": "css-border-top-left-radius"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.Font": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font>",
              "format": "css-font"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.FontFamily": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.String"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-family>",
              "format": "css-font-family"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.FontSize": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-size>",
              "format": "css-font-size"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.FontStretch": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-stretch-absolute>",
              "format": "css-font-stretch"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.FontStyle": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-style>",
              "format": "css-font-style"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.FontVariant": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-variant>",
              "format": "css-font-variant"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.FontWeight": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<font-weight>",
              "format": "css-font-weight"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.LineHeight": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveNumber"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<line-height>",
              "format": "css-line-height"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.LetterSpacing": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<letter-spacing>",
              "format": "css-letter-spacing"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.TextAlign": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-align>",
              "format": "css-text-align"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.TextTransform": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-transform>",
              "format": "css-text-transform"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.TextShadow": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-shadow>",
              "format": "css-text-shadow"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.TextDecoration": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-decoration>",
              "format": "css-text-decoration"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.TextDecorationLine": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-decoration-line>",
              "format": "css-text-decoration-line"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.TextDecorationStyle": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-decoration-style>",
              "format": "css-text-decoration-style"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.TextDecorationThickness": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-decoration-thickness>",
              "format": "css-text-decoration-thickness"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.TextOverflow": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-overflow>",
              "format": "css-text-overflow"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.TextIndent": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<text-indent>",
              "format": "css-text-indent"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.Padding": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<padding>",
              "format": "css-padding",
              "description": "padding shorthand syntax"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.PaddingTop": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<padding-top>",
              "format": "css-padding-top"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.Margin": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "description": "margin shorthand syntax",
              "format": "css-margin"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.MarginTop": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.LengthPercentage"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<length-percentage-auto>",
              "format": "css-margin-top"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.BoxShadow": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<box-shadow>",
              "format": "css-box-shadow"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.Opacity": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Number"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<opacity>",
              "format": "css-opacity"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.Background": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<background>",
              "format": "css-background"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Color"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 2500
        }
      ]
    },
    "CSS.BackgroundSize": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<bg-size>",
              "format": "css-background-size"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.BackgroundImage": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<bg-image>",
              "format": "css-background-image"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 2500
        }
      ]
    },
    "CSS.AlignSelf": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<self-position>",
              "format": "css-align-self"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.HeightOrWidth": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-length-percentage-auto>",
              "format": "css-height-or-width"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.BackgroundClip": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<bg-clip>",
              "format": "css-background-clip"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.BackgroundOrigin": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<origin>",
              "format": "css-background-origin"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.BackgroundPosition": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<bg-position>",
              "format": "css-background-position"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.BackgroundRepeat": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<repeat-style>",
              "format": "css-background-repeat"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.BackgroundAttachment": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<attachment>",
              "format": "css-background-attachment"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.Overflow": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<overflow>",
              "format": "css-overflow"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.OverflowX": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<overflow-block>",
              "format": "css-overflow-x"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.OverflowY": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<overflow-block>",
              "format": "css-overflow-y"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.AlignItems": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<align-items>",
              "format": "css-align-items"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.FlexDirection": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<flex-direction>",
              "format": "css-flex-direction"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.Gap": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.SingleValueGap"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<gap>",
              "format": "css-gap"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.SingleValueGap": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLength"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositivePercentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<positive-length-percentage>",
              "format": "css-single-value-gap"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.JustifyContent": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<justify-content>",
              "format": "css-justify-content"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.FillWithURL": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Color"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<paint>",
              "format": "css-fill-with-url"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.Isolation": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<isolation>",
              "format": "css-isolation"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.MixBlendMode": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.BlendMode"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<mix-blend-mode>",
              "format": "css-mix-blend-mode"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.ObjectFit": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<object-fit>",
              "format": "css-object-fit"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.ObjectPosition": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<object-position>",
              "format": "css-object-position"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.FillOpacity": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Number"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<alpha-value>",
              "format": "css-fill-opacity"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.Stroke": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Color"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<paint>",
              "format": "css-stroke"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.StrokeWidth": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.LengthPercentage"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Length"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<length-percentage>",
              "format": "css-stroke-width"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.StrokeOpacity": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Number"
            },
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.Percentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<alpha-value>",
              "format": "css-stroke-opacity"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.Display": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<display>",
              "format": "css-display"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.Filter": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<filter>",
              "format": "css-filter"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.WritingMode": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<writing-mode>",
              "format": "css-writing-mode"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.MaskImage": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<mask-reference>",
              "format": "css-mask-image"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.MaskMode": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<mask-mode>",
              "format": "css-mask-mode"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.MaskPosition": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<bg-position>",
              "format": "css-mask-position"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.MaskSize": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:cssPropertySchemas.json#/definitions/CSS.PositiveLengthPercentage"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<bg-size>",
              "format": "css-mask-size"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.MaskRepeat": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<repeat-style>",
              "format": "css-mask-repeat"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.MaskOrigin": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<mask-origin>",
              "format": "css-mask-origin"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.MaskClip": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<mask-clip>",
              "format": "css-mask-clip"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.MaskComposite": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<mask-composite>",
              "format": "css-mask-composite"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    },
    "CSS.Mask": {
      "allOf": [
        {
          "anyOf": [
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<var()>"
            },
            {
              "type": "string",
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<mask>",
              "format": "css-mask"
            },
            {
              "$ref": "urn:dm:schemas:css-value-definitions.schema.json#/definitions/<global-values>"
            }
          ]
        },
        {
          "maxLength": 150
        }
      ]
    }
  }
}
